import { FunctionComponent } from "react";

const MainstreamBrands: FunctionComponent = () => {
  return (
    <div className="self-stretch h-[368px] flex flex-row items-start justify-start py-0 px-[39px] box-border max-w-full text-left text-5xl text-black font-radley">
      <div className="h-[308px] flex-1 overflow-x-auto flex flex-row items-start justify-start gap-[60px] max-w-full mq750:gap-[30px]">
        <div className="h-[120px] w-[200px] shrink-0 flex flex-col items-start justify-start p-2.5 box-border">
          <img
            className="self-stretch flex-1 relative max-w-full overflow-hidden max-h-full object-cover"
            loading="eager"
            alt=""
            src="/logo3@2x.png"
          />
        </div>
        <div className="h-[258px] w-[197px] shrink-0 flex flex-col items-start justify-start pt-2.5 px-0 pb-0 box-border text-gray-600">
          <div className="w-[187px] flex-1 relative flex items-center mq450:text-lgi">
            <span className="w-full">
              <p className="m-0 text-13xl">{`Contact `}</p>
              <p className="m-0">&nbsp;</p>
              <p className="m-0">Address</p>
              <p className="m-0">Phone Number</p>
              <p className="m-0">Email Address</p>
              <p className="m-0">Sales Department</p>
              <p className="m-0">Manager</p>
              <p className="m-0">Parts Department</p>
            </span>
          </div>
        </div>
        <div className="h-[268px] w-[216px] shrink-0 flex flex-col items-start justify-start pt-2.5 px-0 pb-0 box-border">
          <div className="w-[206px] flex-1 relative flex items-center mq450:text-lgi">
            <span className="w-full">
              <p className="m-0 text-13xl">{`Mainstream Brands `}</p>
              <p className="m-0">&nbsp;</p>
              <p className="m-0">Trek</p>
              <p className="m-0">Giant</p>
              <p className="m-0">Cannondale</p>
              <p className="m-0">Specialized</p>
              <p className="m-0">Santa Cruz</p>
            </span>
          </div>
        </div>
        <div className="h-[268px] w-[292px] shrink-0 flex flex-col items-start justify-start pt-2.5 px-0 pb-0 box-border">
          <div className="w-[282px] flex-1 relative flex items-center mq450:text-lgi">
            <span className="w-full">
              <p className="m-0 text-13xl">{`Direct-to-Consumer Brands `}</p>
              <p className="m-0">&nbsp;</p>
              <p className="m-0">Canyon</p>
              <p className="m-0">YT Industries</p>
              <p className="m-0">Commencal</p>
              <p className="m-0">&nbsp;</p>
            </span>
          </div>
        </div>
        <div className="self-stretch w-[207px] shrink-0 flex flex-col items-start justify-start pt-2.5 px-0 pb-0 box-border">
          <div className="self-stretch flex-1 relative flex items-center mq450:text-lgi">
            <span>
              <p className="m-0 text-13xl">{`Emerging & Boutique Brands `}</p>
              <p className="m-0">&nbsp;</p>
              <p className="m-0">Yeti Cycles</p>
              <p className="m-0">Pivot Cycles</p>
              <p className="m-0">Evil Bikes</p>
              <p className="m-0">Norco</p>
              <p className="m-0">Juliana</p>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainstreamBrands;
